<template>
  <div v-show="show" class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-image class="integral-bg" :src="intBg" width="100%" />
      <div class="pos">
        <img class="rule" v-if="detail.rule" @click="goStatePage(2)" src="https://i.xurl.cn/x_dsx_h5/inte/ruleBg.png" />
        <img class="tips" v-if="detail.tips" @click="goStatePage(1)" src="https://i.xurl.cn/x_dsx_h5/inte/tipsBg.png" />
      </div>
      <div class="middle-bar">
        <div class="left">
          <van-icon class="gold-coin" :name="GoldCoin" :size="transPxToRem(20)" />
          <div class="title">当前{{ integralName }}</div>
          <div class="num">{{ totalIntegral }}</div>
        </div>
        <div class="right" @click="navigateTo('/integral')">
          <div class="right-label">{{ integralName }}账单</div>
          <van-icon color="#999" name="arrow" :size="transPxToRem(12)" />
        </div>
      </div>
      <div class="content-box">
        <van-sticky>
          <van-tabs
            v-model:active="tabActive"
            title-active-color="#222"
            color="#222"
            line-width="28px"
            line-height="4px"
            @click-tab="onClickTab"
            :disabled="loading"
          >
            <van-tab v-for="item in tabData" :title="item.label" :key="item.value" :name="item.value" />
          </van-tabs>
        </van-sticky>
        <div class="van-hairline--bottom"></div>
        <van-list
          class="list-container"
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          :immediate-check="false"
          @load="getList"
        >
          <div class="goods-list con-wrp" v-if="tabActive === TabTypeEmu.GOODS">
            <div
              v-for="item in list"
              :key="item.rid"
              class="goods-list-item"
              @click="goGoodsDetails(item.goodsId, item.stock === 0)"
            >
              <div class="image-wrp">
                <van-image :src="item.goodsMainImg" :width="transPxToRem(156)" :height="transPxToRem(156)" />
                <div class="image-cover" v-if="item.stock === 0">
                  <!-- <div class="round">已兑完</div> -->
                  <van-image :src="exchangedIcon" :width="transPxToRem(100)" :height="transPxToRem(100)" />
                </div>
              </div>
              <div class="title van-multi-ellipsis--l2">{{ item.goodsName }}</div>
              <div class="price">
                <div class="left">
                  <van-icon class="gold-coin" :name="GoldCoin" :size="transPxToRem(16)" />
                  <div class="integral-price van-ellipsis">
                    <span class="integral-price-num">{{ item.integral }}</span
                    >{{ integralName }}<template v-if="item.salePrice">+<Price :price="item.salePrice" />元</template>
                  </div>
                </div>
                <!-- <div class="right">￥{{ item.marketingPrice }}</div> -->
              </div>
              <div class="btn-wrp">
                <van-button
                  v-if="item.stock === 0"
                  class="btn"
                  disabled
                  block
                  round
                  color="linear-gradient( 176deg, #FFA645 0%, #FB6227 100%)"
                  >已兑完</van-button
                >
                <van-button block round v-else-if="isIntegralNotEnough(item.integral)" class="btn" color="#D8D8D8"
                  >{{ integralName }}不足</van-button
                >
                <van-button
                  v-else
                  block
                  round
                  class="btn"
                  @click="goGoodsDetails(item.goodsId, item.stock === 0)"
                  color="linear-gradient( 176deg, #FFA645 0%, #FB6227 100%)"
                  >立即兑换</van-button
                >
              </div>
            </div>
          </div>
          <div class="coupon-list" v-if="tabActive === TabTypeEmu.COUPON">
            <div class="coupon-list-item" v-for="item in list" :key="item.couponId" @click="goCouponDetails(item)">
              <div class="left">
                <div class="price">
                  <couponPrice :price="item.couponValue" />
                  <div class="condition">
                    {{
                      item.useConditionType === 1
                        ? '无门槛'
                        : `满${item.useConditionValue}${item.useConditionType === 2 ? '元' : '件'}可用`
                    }}
                  </div>
                </div>
              </div>
              <div class="des">
                <div class="title van-ellipsis">{{ item.couponName }}</div>
                <div>{{ item.couponEffectDay ? '有效时间' : '有效期至' }}</div>
                <template v-if="item.couponEffectDay">
                  <div>领取后{{ item.couponEffectDay }}天内有效</div>
                </template>
                <template v-else>
                  <div>{{ item.effectiveTime }}</div>
                </template>
              </div>
              <div class="divider"></div>
              <div class="right">
                <div class="num-box">
                  <van-icon class="gold-coin" :name="GoldCoin" :size="transPxToRem(12)" />
                  <span class="num">{{ item.integral }}</span>
                </div>
                <van-button round v-if="isIntegralNotEnough(item.integral)" class="btn" color="#D8D8D8"
                  >{{ integralName }}不足</van-button
                >
                <van-button
                  v-else
                  round
                  class="btn"
                  loading-text="兑换中"
                  color="linear-gradient( 176deg, #FFA645 0%, #FB6227 100%)"
                  >立即兑换</van-button
                >
              </div>
            </div>
          </div>
        </van-list>
        <van-empty
          v-if="list.length == 0 && !loading"
          image-size="240"
          image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png"
          description="暂无数据"
        />
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive, computed, onBeforeMount } from 'vue'
import {
  getIntegralShopCouponListApi,
  getUserIntegralInfoApi,
  getStateIsEmptyApi,
  getIntegralShopGoodsListApi
} from '@/api/integral'
import couponPrice from '../coupon/component/couponPrice.vue'
import int_def_bg from '@/assets/img/integral_store_bg.png'
import exchangedIcon from '@/assets/img/exchanged.png'
import GoldCoin from '@/assets/img/gold_coin.png'
import { transPxToRem } from '@/utils'
import usePage from '@/hooks/usePage'
import { WxPage } from '../../enum'
import Price from '@/components/Price.vue'
import { useUserStore } from '@/store/user'
import { getStateApi } from '@/api/setting'

const TabTypeEmu = {
  GOODS: 'goods',
  COUPON: 'coupon'
}
const show = ref(false)
const totalIntegral = ref(0)
const tabActive = ref(TabTypeEmu.GOODS)
const { navigateTo } = usePage()
const { goWxAppPage } = usePage()
const userStore = useUserStore()
const projectInfo = userStore.getProjectInfo
const intBg = ['warmhome', 'xingmahui'].includes(projectInfo.projectRule)
  ? `https://i.xurl.cn/x_dsx_h5/bg/bg-integralShop_${projectInfo.projectRule}.png`
  : int_def_bg
const ruleDetail = ref([])
const detail = reactive({
  rule: false,
  tips: false
})
const tabData = ref([
  {
    label: '商品',
    value: TabTypeEmu.GOODS
  },
  {
    label: '优惠券',
    value: TabTypeEmu.COUPON
  }
])

const pageParams = reactive({
  page: 1,
  pageSize: 20
})
const postParams = ref({})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const onClickTab = () => {
  reset()
  getList()
}

const reset = () => {
  list.value = []
  pageParams.page = 1
  finished.value = false
}
const getList = async () => {
  loading.value = true
  try {
    const params = { ...pageParams, ...postParams.value }
    const resData =
      tabActive.value == TabTypeEmu.COUPON
        ? await getIntegralShopCouponListApi(params)
        : await getIntegralShopGoodsListApi(params)
    list.value.push(...resData.list)
    pageParams.page++
    finished.value = list.value.length === Number(resData.total)
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const goCouponDetails = ({ integral, couponId, activityId }) => {
  if (!isIntegralNotEnough(integral)) {
    navigateTo(`/couponDetails?couponId=${couponId}&activityId=${activityId}`)
  }
}

const goGoodsDetails = (goodsId, isExchange = false) => {
  !isExchange && goWxAppPage(`${WxPage.goodsDetails}?goodsId=` + goodsId + '&comeType=10')
}

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    reset()
    getList()
    await getUserIntegral()
  } finally {
    refreshing.value = false
  }
}

const isIntegralNotEnough = integral => Number(integral) > totalIntegral.value
const goStatePage = type => navigateTo(`/state?type=${type}`)

const getUserIntegral = async () => {
  const resData = await getUserIntegralInfoApi()
  return new Promise((resolve, reject) => {
    if (resData) {
      totalIntegral.value = Number(resData.integralBalance)
      detail.rule = resData.isRuleDetail
      detail.tips = resData.isExchangeDetail
      resolve(true)
    } else {
      reject(false)
    }
  })
}

const getStateIsEmpty = async () => {
  const resData = await getStateIsEmptyApi()
  detail.rule = resData.isRuleDetail
  detail.tips = resData.isExchangeDetail
}

onMounted(async () => {
  try {
    await getUserIntegral()
    getList()
    getStateIsEmpty()
  } catch (e) {
    console.log(e)
  }
})
onBeforeMount(() => {
  document.title = projectInfo.projectRule === 'xingmahui' ? '复购专区' : projectInfo.integralName + '商城'
  if (userStore.getSettingInfo?.isIntegralShop) {
    show.value = true
    return
  }
  showDialog({
    title: '温馨提示',
    message: '暂无权限访问该页面，请联系客服',
    confirmButtonText: '知道啦'
  }).then(() => {
    wx.miniProgram.navigateBack()
  })
})
</script>
<style lang="less" scoped>
.pos {
  position: absolute;
  top: 40px;
  right: 0;
  .rule {
    width: 40px;
    height: 28px;
    margin-bottom: 16px;
  }
  .tips {
    width: 40px;
    height: 28px;
  }
}
.page-container {
  font-size: 14px;
  background-color: #fac77e;
  height: fit-content;
  min-height: 100vh;
  .middle-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 8px;
    padding: 14px 12px;
    margin: 15px 12px 8px 12px;
    .left {
      display: flex;
      align-items: center;
      .title {
        color: #222;
        font-weight: 500;
        margin: 0 8px;
      }
      .num {
        color: #ff6060;
        font-weight: 800;
        font-size: 24px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .right-label {
        color: #999999;
      }
    }
  }
  .content-box {
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin: 15px 12px 8px 12px;
    .goods-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 16px 12px;
      .goods-list-item {
        margin-bottom: 16px;
        max-width: 156px;
        .image-wrp {
          overflow: hidden;
          border-radius: 8px;
          border: 1px solid #f6f6f6;
          position: relative;
          height: 156px;
          .image-cover {
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.4);
          }
        }
        .title {
          font-weight: bold;
          color: #222222;
          line-height: 22px;
          margin-top: 8px;
          max-width: 100%;
          height: 44px;
        }
        .price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 4px;
          .left {
            display: flex;
            align-items: center;
            .gold-coin {
              margin-right: 4px;
            }
            .integral-price {
              color: #ff6060;
              font-weight: bold;
              font-size: 12px;
              max-width: 136px;
              .integral-price-num {
                font-size: 16px;
              }
            }
          }
          // .right {
          //   text-decoration-line: line-through;
          //   color: #c8c8c8;
          //   font-size: 11px;
          // }
        }
        .btn-wrp {
          display: flex;
          justify-content: center;
          margin-top: 12px;
          .btn {
            // width: 100%;
            height: 32px;
            background: #ffffff;
            // border-radius: 4px;
          }
        }
      }
    }
    .coupon-list {
      margin-top: 16px;
      .coupon-list-item {
        margin: 12px;
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        justify-content: space-between;
        align-items: stretch;
        .left {
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
          background: #f6f6f6;
          padding-left: 4px;
          padding-right: 4px;
          padding-top: 10px;
          padding-bottom: 10px;
          // height: 84px;
          display: flex;
          .price {
            color: #ff6060;
            font-size: 11px;
            flex-direction: column;
            display: flex;
            align-items: center;
            width: 80px;
            .condition {
              margin-top: 2px;
            }
          }
        }
        .divider {
          border-right: 1px dashed #d8d8d8;
          height: 72px;
          position: relative;
          top: 7px;
        }
        .des {
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
          color: #999999;
          background: #f6f6f6;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 16px;
          padding-top: 16px;
          padding-bottom: 16px;
          font-size: 12px;
          .title {
            color: #222;
            font-weight: bold;
            font-size: 14px;
            max-width: 120px;
            // padding-right: 23px;
            margin-bottom: 8px;
          }
          .condition {
            margin: 4px 0;
          }
        }
        .right {
          background: #f6f6f6;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          border-radius: 8px;
          width: 100px;
          align-items: center;
          .num-box {
            display: flex;
            align-items: center;
          }
          .num {
            color: #ff6060;
            font-weight: 800;
            margin-left: 2px;
          }
          .btn {
            width: 68px;
            height: 28px;
            background: #ffffff;
            // border-radius: 4px;
            font-size: 12px;
            margin-top: 6px;
            padding: 0;
          }
        }
      }
    }
  }
}
</style>
